/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useState } from 'react';
import { WarningOutline } from 'react-ionicons';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { PageContainer, PageContent } from '../component/Containers/Containers';
import GestionItem from '../component/ListItem/GestionItem';
import useForceUpdate from '../hooks/useForceUpdate';
import { setIsLoadingTo } from '../store/features/adminSlice';
import {
  compareAndUpdateFavorites,
  compareAndUpdateRecents,
  getStations,
  setFavorites,
  setProvince,
} from '../store/features/stationSlice';
import { HttpListClient } from '../utils/HttpClient';
import Swal from 'sweetalert2';
import localforage from 'localforage';

/**
 * @component
 * returns the admin gestion view, displayes all stations active or inactive,
 * allows to edit and allows the option to add a new station.
 * @returns {void}
 */

const Gestion = () => {
  const dispatch = useDispatch();

  const favouriteStorage = localforage.createInstance({
    name: 'favorites',
  });

  const getStationsFromApi = async () => {
    dispatch(setIsLoadingTo(true));
    let res;
    try {
      let { data } = await HttpListClient.get('/getStations');
      let provinceData = await HttpListClient.get('/getProvinces');
      let favs = (await favouriteStorage.getItem('favs')) ?? [];
      dispatch(setFavorites(favs));
      dispatch(compareAndUpdateRecents());
      dispatch(compareAndUpdateFavorites());
      res = JSON.parse(atob(data)) ?? [];
      await dispatch(getStations(res));
      await dispatch(setProvince(provinceData.data));
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'Error',
        text: 'Parece haber un problema con la conexion por favor intente mas tarde.',
        icon: 'warning',
        iconColor: '#FFD732',
        confirmButtonColor: '#003876',
      });
      await dispatch(getStations([]));
    }
    dispatch(setIsLoadingTo(false));
  };

  const {
    isSearching,
    favouriteStations,
    filteredList,
    isFiltering,
    stateSearchList,
    searchByState,
    allStations,
  } = useSelector((state) => state.stations);

  const { isLoading } = useSelector((state) => state.admin);
  const [stations, setStations] = useState([...allStations]);

  const createNewCopy = (arr) => {
    let map = [];
    arr.forEach((item, index) => {
      map[index] = Object.assign({}, item);
    });
    return map;
  };

  useEffect(() => {
    setImmediate(async () => await getStationsFromApi());
    dispatch(compareAndUpdateRecents());
  }, []);

  useEffect(() => {
    let map = createNewCopy(allStations);
    let favs = createNewCopy(favouriteStations);
    favs.forEach((stationA) => {
      map.forEach((stationB) => {
        if (stationA.Id == stationB.Id) {
          stationB.Favorite = true;
        }
      });
    });
    setStations(map);
    dispatch(setIsLoadingTo(false));
  }, []);

  useEffect(() => {
    setStations(filteredList);
  }, [filteredList, isFiltering]);

  useEffect(() => {
    let map = createNewCopy(allStations);
    let favs = createNewCopy(favouriteStations);
    favs.forEach((stationA) => {
      map.forEach((stationB) => {
        if (stationA.Id == stationB.Id) {
          stationB.Favorite = true;
        }
      });
    });
    setStations(map);
  }, [allStations]);

  useEffect(() => {
    setImmediate(async () => {
      let { data } = await HttpListClient.get('/getStations');
      let res = JSON.parse(atob(data)) ?? [];
      await dispatch(getStations(res));
    });
  }, [searchByState]);

  useEffect(() => {
    setStations(stateSearchList);
  }, [searchByState]);

  /**
   * @component
   *  returns the filtered stations rendered inside gestion Items
   * @returns {void}
   */
  const displayFilteredStations = () =>
    filteredList.length
      ? filteredList.map((station, index) => (
          <React.Fragment key={index}>
            <GestionItem key={station.Id} station={station} />
          </React.Fragment>
        ))
      : noFilteredAvailable();
  const displayFilteredByState = () =>
    stateSearchList.length
      ? stateSearchList.map((station, index) => (
          <React.Fragment key={index}>
            <GestionItem key={station.Id} station={station} />
          </React.Fragment>
        ))
      : noFilteredByStateAvailable();

  const noFilteredAvailable = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '90%',
        color: '#003876',
        fontWeight: '400',
        padding: '0 20px 0 10px',
      }}>
      <WarningOutline
        color={'#003876'}
        height="25px"
        width="25px"
        styled={{
          display: 'block !important',
          marginLeft: 'auto',
          marginRight: '10px',
        }}
      />
      <h4 style={{ display: 'block', margin: '0', marginLeft: '5px' }}>
        Ninguna estación disponible concuerda con su búsqueda
      </h4>
    </div>
  );

  /**
   * @component
   * returns the text displayed when searching and no matches are found
   * @returns {void}
   */
  const noFilteredByStateAvailable = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '90%',
        color: '#003876',
        fontWeight: '400',
        padding: '0 10px 0 10px',
      }}>
      <WarningOutline
        color={'#003876'}
        height="25px"
        width="25px"
        styled={{
          display: 'block !important',
          marginLeft: 'auto',
          marginRight: '10px',
        }}
      />
      <h3 style={{ display: 'inline-block', marginLeft: '5px' }}>
        Ninguna Emisora Concuerda con ese Estado
      </h3>
    </div>
  );

  return (
    <>
      <PageContainer>
        <PageContent style={{ marginTop: '25px' }}>
          {isLoading ? null : isSearching && isFiltering ? (
            stations.length ? (
              stations.map((station, index) => (
                <React.Fragment key={index}>
                  <GestionItem key={station.Id} station={station} />
                </React.Fragment>
              ))
            ) : (
              noFilteredAvailable()
            )
          ) : isSearching ? (
            displayFilteredStations()
          ) : isFiltering ? (
            displayFilteredByState()
          ) : isSearching && !filteredList.length ? (
            noFilteredAvailable()
          ) : ![...stations].length ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                color: '#003876',
                fontWeight: '400',
                textAlign: 'center',
                padding: '0 10px 0 10px',
              }}>
              <h2>No hay emisoras disponibles.</h2>
            </div>
          ) : [...stations].length > 0 ? (
            [...stations]
              .sort((a, b) => a.Name.toString().localeCompare(b.Name))
              .map((station, index) => (
                <React.Fragment key={index}>
                  <GestionItem
                    max={'420px'}
                    key={station.Id}
                    station={station}
                  />
                </React.Fragment>
              ))
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                color: '#003876',
                fontWeight: '400',
                textAlign: 'center',
                padding: '0 10px 0 10px',
              }}>
              <h2>No hay emisoras disponibles.</h2>
            </div>
          )}
        </PageContent>
      </PageContainer>
    </>
  );
};

export default Gestion;
